export const API_GET_ALL_PARTNERS = "API_GET_ALL_PARTNERS";
export const API_GET_ALL_PARTNERS_SUCCESS = "API_GET_ALL_PARTNERS_SUCCESS";
export const API_GET_ALL_PARTNERS_FAIL = "API_GET_ALL_PARTNERS_FAIL";

export const API_ADMIN_GET_ALL_PARTNERS = "API_ADMIN_GET_ALL_PARTNERS";
export const API_ADMIN_GET_ALL_PARTNERS_SUCCESS = "API_ADMIN_GET_ALL_PARTNERS_SUCCESS";
export const API_ADMIN_GET_ALL_PARTNERS_FAIL = "API_ADMIN_GET_ALL_PARTNERS_FAIL";

export const API_ADMIN_GET_PARTNER = "API_ADMIN_GET_PARTNER";
export const API_ADMIN_GET_PARTNER_SUCCESS = "API_ADMIN_GET_PARTNER_SUCCESS";
export const API_ADMIN_GET_PARTNER_FAIL = "API_ADMIN_GET_PARTNER_FAIL";

export const API_ADMIN_PATCH_PARTNER = "API_ADMIN_PATCH_PARTNER";
export const API_ADMIN_PATCH_PARTNER_SUCCESS = "API_ADMIN_PATCH_PARTNER_SUCCESS";
export const API_ADMIN_PATCH_PARTNER_FAIL = "API_ADMIN_PATCH_PARTNER_FAIL";

export const API_ADMIN_POST_PARTNER = "API_ADMIN_POST_PARTNER";
export const API_ADMIN_POST_PARTNER_SUCCESS = "API_ADMIN_POST_PARTNER_SUCCESS";
export const API_ADMIN_POST_PARTNER_FAIL = "API_ADMIN_POST_PARTNER_FAIL";

export const API_ADMIN_DELETE_PARTNER = "API_ADMIN_DELETE_PARTNER";
export const API_ADMIN_DELETE_PARTNER_SUCCESS = "API_ADMIN_DELETE_PARTNER_SUCCESS";
export const API_ADMIN_DELETE_PARTNER_FAIL = "API_ADMIN_DELETE_PARTNER_FAIL";

export const ADMIN_INIT_NEW_PARTNER = "ADMIN_INIT_NEW_PARTNER";

export const ADMIN_RESET_FOCUS_PARTNER = "ADMIN_RESET_FOCUS_PARTNER";
